import attachmentPluginTrigger from './utils/attachmentPluginTrigger';
import { LazyModule } from 'owa-bundling';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Editor" */ './lazyIndex');
});
export var LazyAttachmentPluginClass = createLazyPlugin(lazyModule, function (m) { return m.AttachmentPlugin; }, 'Attachment', attachmentPluginTrigger, true /* reusable when switching from inline compose to full compose */);
//# sourceMappingURL=index.js.map